import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MovieService {

  constructor() { }

  setTrendingData(data :any){
    localStorage.setItem('Trending',data)
  }
  getTrendingData(){
  let getData = localStorage.getItem('Trending');

  return getData;
  }

}
